import {Parameter, ToolboxSplitSplit} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalToolboxSplitSplit extends ToolboxSplitSplit implements Parameter {
	public deleteSource?: boolean;
	public pageNumber?: number;

	constructor(data: any) {
		super(data);

		this.deleteSource = FunctionHelper.exists(data?.deleteSource) ? data.deleteSource : false;
		this.pageNumber = FunctionHelper.exists(data?.pageNumber) ? data.pageNumber : 1;
	}

	public static getDeleteSourceDefault(): boolean {
		return false;
	}

	public static getPageNumberDefault(): number {
		return 1;
	}

	public static getPageNumberMin(): number {
		return 1;
	}

	public static fromJson(data: any): PortalToolboxSplitSplit {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalToolboxSplitSplit(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'deleteSource': this.deleteSource,
			'pageNumber': this.pageNumber
		};
	}

	public clone(): PortalToolboxSplitSplit {
		return PortalToolboxSplitSplit.fromJson(this.toJson());
	}
}